(function() {
  angular
    .module('cfn')
    .service('dRow.service', function() {
      'use strict';

      return {
        getFixedOrDynamicWidth: getFixedOrDynamicWidth,
        checkHideifValue: checkHideifValue
      };

      function getFixedOrDynamicWidth(tcFixedWidth, tcWidth) {
        var cssClassPrefix, width, intWidth;

        switch (true) {
          case !!tcFixedWidth:
            cssClassPrefix = 'fixed-';
            width = tcFixedWidth;
            break;
          case !!tcWidth:
            cssClassPrefix = 'tc-';
            width = tcWidth;
            break;
          default:
            cssClassPrefix = 'tc-';
            width = 1;
        }

        intWidth = parseInt(width);

        // Error handling:

        if (intWidth != width) {
          console.error(
            'Directive <d-row-cell>: tc-width and tc-fixed-width have to be integer values.'
          );
        }

        return {
          cssClassPrefix: cssClassPrefix,
          width: intWidth
        };
      }

      function checkHideifValue(hideIfValue) {
        return hideIfValue === true || hideIfValue === 'true' ? true : false;
      }
    })
    .directive('dMultiRow', [
      '$q',
      '$compile',
      function($q, $compile) {
        'use strict';

        function deactivateHTML(html) {
          return '<!--' + html + '-->';
        }

        function reactivateHTML(html) {
          return html.substr(4, html.length - 7);
        }

        function getRenderedRows(multirowmodel, innerRow, startIndex) {
          return {
            html: _.reduce(
              multirowmodel,
              function(cumulated, rowItem) {
                return {
                  indx: cumulated.indx + 1,
                  allRows:
                    cumulated.allRows +
                    "<d-row rowmodel='multirowmodel[" +
                    cumulated.indx +
                    "]'>" +
                    innerRow +
                    '</d-row>'
                };
              },
              {
                indx: startIndex || 0,
                allRows: ''
              }
            ),

            itemCount: multirowmodel.length
          };
        }

        function getRenderedRowsGrouped(groupedmultirowModel, innerRow) {
          var groupDirective = angular
              .element(innerRow)
              .siblings('d-row-grouped'),
            groupDirectiveHtml = groupDirective.html();

          groupDirective.remove();

          return {
            html: _.reduce(
              groupedmultirowModel,
              function(cumulated, groupByItem) {
                var rowsHtml = getRenderedRows(
                  groupByItem.rowGroup,
                  innerRow,
                  cumulated.allItemCount
                );
                return {
                  indx: cumulated.indx + 1,
                  allItemCount: cumulated.allItemCount + rowsHtml.itemCount,
                  allRows:
                    "<d-row rowmodel='multirowGroupBymodel[" +
                    cumulated.indx +
                    "]''>" +
                    groupDirectiveHtml +
                    '</d-row>' +
                    rowsHtml.html.allRows +
                    cumulated.allRows
                };
              },
              {
                indx: 0,
                allItemCount: 0,
                allRows: ''
              }
            )
          };
        }

        function getRenderedInnerHtml(
          iElement,
          multirowmodel,
          htmlTemplate,
          isGrouped
        ) {
          var rowHtml, innerRow, allRowsHtml;

          innerRow = htmlTemplate;

          if (!isGrouped) {
            allRowsHtml = getRenderedRows(multirowmodel, innerRow).html;
          } else {
            allRowsHtml = getRenderedRowsGrouped(multirowmodel, innerRow).html;
          }

          return allRowsHtml.allRows;
        }

        return {
          restrict: 'E',
          scope: {
            multirowmodel: '=',
            groupingFn: '='
          },
          template: function(element, attrs) {
            var inner = element.html();

            return deactivateHTML(inner);
          },
          link: function(scope, iElement, attrs, dRowController) {
            var htmlTemplateStore = reactivateHTML(iElement.html());

            // deep watch model
            scope.$watch(
              'multirowmodel',
              function(newVal, oldVal) {
                var renderedHtml,
                  isFirstWatch = !newVal && !oldVal,
                  hasEmptyModel = !newVal,
                  hasGroupingFunction = _.isFunction(scope.groupingFn);

                switch (true) {
                  case isFirstWatch:
                    return;
                    break;

                  case hasEmptyModel:
                    renderedHtml = '';
                    break;

                  case hasGroupingFunction:
                    scope.multirowGroupBymodel = scope.groupingFn(
                      scope.multirowmodel
                    );
                    renderedHtml = getRenderedInnerHtml(
                      iElement,
                      scope.groupingFn(scope.multirowmodel),
                      htmlTemplateStore,
                      true
                    );
                    break;

                  default:
                    renderedHtml = getRenderedInnerHtml(
                      iElement,
                      scope.multirowmodel,
                      htmlTemplateStore,
                      false
                    );
                }

                iElement.html($compile(renderedHtml)(scope));
              },
              true
            );
          }
        };
      }
    ])
    .directive('dRow', [
      '$compile',
      '$q',
      'dRow.service',
      function($compile, $q, dRowService) {
        'use strict';
        return {
          restrict: 'E',
          scope: {
            rowmodel: '='
          },
          controller: [
            '$scope',
            '$element',
            function($scope, $element) {
              var ctrl = this,
                childInterfaceList = [],
                columnCount;

              ctrl.addChildInterface = function(scope) {
                childInterfaceList.push(scope);
              };

              ctrl.reTriggerColoumnCount = function() {
                ctrl.setColoumnCountElemClass(
                  $scope,
                  ctrl.getChildColoumnCount()
                );
              };

              ctrl.getChildColoumnCount = function() {
                columnCount = _.reduce(
                  childInterfaceList,
                  function(columnCounter, childIFace) {
                    var dynWidth = dRowService.getFixedOrDynamicWidth(
                        childIFace.tcFixedWidth,
                        childIFace.tcWidth
                      ),
                      hasAttrTcFixedWidth =
                        dynWidth.cssClassPrefix === 'fixed-',
                      dontCount =
                        childIFace.isHiddenCell || hasAttrTcFixedWidth;

                    return columnCounter + (dontCount ? 0 : dynWidth.width);
                  },
                  0
                );

                return columnCount;
              };

              ctrl.setColoumnCountElemClass = function(scope, columnCount) {
                removeAllColoumnClasses();
                $element.addClass('tr-' + columnCount);
              };

              function removeAllColoumnClasses() {
                $element.removeClass(function(index, css) {
                  return (css.match(/\btr-\S+/g) || []).join(' ');
                });
              }

              // Error handling:
              if (columnCount > 36) {
                console.error(
                  'Directive <d-row>: More than 36 coloumns in total are not supported.'
                );
              }
            }
          ],
          template: function(element, attrs) {
            var inner = element.html();

            return inner;
          },
          compile: function(element, attrs) {
            return {
              post: function(scope, iElement, iAttrs, dRowCtrl) {
                dRowCtrl.setColoumnCountElemClass(
                  scope,
                  dRowCtrl.getChildColoumnCount()
                );
              }
            };
          }
        };
      }
    ])
    .directive('dRowCell', [
      'dRow.service',
      function(dRowService) {
        'use strict';

        function watchAttrHideCellIf(
          scope,
          data,
          elem,
          hidecellifReference,
          dRowController
        ) {
          scope.$watch(
            function() {
              return scope.$eval(hidecellifReference);
            },
            function(newValue) {
              data.isHiddenCell = newValue;

              if (dRowService.checkHideifValue(newValue)) {
                hide(elem);
                dRowController.reTriggerColoumnCount();
              } else {
                show(elem);
                dRowController.reTriggerColoumnCount();
              }
            }
          );
        }

        function hide(elem) {
          elem.addClass('display-none');
        }

        function show(elem) {
          elem.removeClass('display-none');
        }

        return {
          restrict: 'E',
          require: '^dRow',
          template: function(element, attrs) {
            var inner = element.html(),
              tcFixedWidth = element.attr('tc-fixed-width'),
              tcWidth = element.attr('tc-width'),
              dynWidth = dRowService.getFixedOrDynamicWidth(
                tcFixedWidth,
                tcWidth
              );

            element.addClass(dynWidth.cssClassPrefix + dynWidth.width);

            // Error handling:

            if (tcFixedWidth && tcWidth) {
              console.error(
                'Directive <d-row-cell>: Cannot use both tc-width and tc-fixed-width parameters at the same time. tcFixedWidth: ' +
                  tcFixedWidth +
                  ' trWidth:' +
                  tcWidth
              );
            } else if (tcFixedWidth > 56) {
              console.error(
                'Directive <d-row-cell>: More than 56 coloumns of tc-fixed-width are not supported.'
              );
            } else if (tcWidth > 36) {
              console.error(
                'Directive <d-row-cell>: More than 36 coloumns of tc-width are not supported.'
              );
            }

            return '<span>' + inner + '</span>';
          },
          link: function(scope, element, attrs, dRowController) {
            var hidecellifReference = attrs.hidecellif,
              cellToRowInterface = {
                tcFixedWidth: element.attr('tc-fixed-width'),
                tcWidth: element.attr('tc-width'),
                isHiddenCell: !!(
                  hidecellifReference ||
                  dRowService.checkHideifValue(scope.$eval(hidecellifReference))
                )
              };

            dRowController.addChildInterface(cellToRowInterface);

            if (hidecellifReference) {
              watchAttrHideCellIf(
                scope,
                cellToRowInterface,
                element,
                hidecellifReference,
                dRowController
              );
            }
          }
        };
      }
    ]);
})();
